import { IWidget } from 'common/schema/widget/Widget';
import { CheckboxOptionType } from 'antd/lib/checkbox';

/**
 * Provvede a trasformare le lista delle opzioni del Widget
 * in una lista valida per Checkbox e Radio
 * includendo anche gli stili per la visualizzazione verticale
 */
export function getWidgetCheckboxOptions(
  widget: IWidget
): CheckboxOptionType[] {
  const input = widget.input!;

  // TODO: EVENTUALMENTE per gestire visualizzazione inline
  const inline = false;
  const radioStyle = inline
    ? {}
    : {
        display: 'flex',
        minHeight: '30px',
        paddingBottom: '5px'
      };

  return widget.input!.options.map(option => ({
    value: option.value,
    label: option.label,
    style: radioStyle
  }));
}
